import { AvTooltip } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { IconButton, iconButtonClasses, IconButtonProps } from '@mui/material';
import { PendoFeature } from '../../../../utils/pendo/PendoFeature';
import { AllTypeWidgets, PieSubType, TileSubType } from '../../types';
import { VennSubType } from '../../types/VennWidget.types';
import { widgetTypeTitleMap } from '../Widgets/widgetTypeTitleMap';
import { WidgetTypeIcon } from '../WidgetTypeIcon/WidgetTypeIcon';

type WidgetType = Exclude<AllTypeWidgets['type'], TileSubType.Score | VennSubType | PieSubType.PieWithNeedle>;

export const WidgetTypeIconButton = ({
  selected = false,
  type,
  sx,
  ...props
}: {
  selected?: boolean;
  type: WidgetType;
} & Omit<IconButtonProps, 'children' | 'type'>) => (
  <AvTooltip title={widgetTypeTitleMap[type]}>
    <IconButton
      data-pendo-id={PendoFeature.WidgetTypeIconButton}
      sx={{
        ...flex.center,
        borderRadius: '8px',
        border: `1px solid transparent`,
        ...(selected && { borderColor: `var(--color-border-base-secondary)` }),
        [`&.${iconButtonClasses.root}`]: {
          px: '4px',
          py: '3px',
        },
        ...sx,
      }}
      {...props}>
      <WidgetTypeIcon type={type} />
    </IconButton>
  </AvTooltip>
);
